(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["inspiration-by"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    
    const stickerText = document.querySelector('.inspired-sticker__text');
    if (!stickerText) return;

    const part1 = stickerText.dataset.inspiredPart1 || '';
    const part2 = stickerText.dataset.inspiredPart2 || '';
    const part3 = stickerText.dataset.inspiredPart3 || '';

    const fullText = part1 + part2 + part3;

    if (fullText.trim().length > 0) {
      const span = document.createElement('span');
      span.textContent = fullText.trim();
      stickerText.append(span);
      stickerText.closest('.inspired-sticker').classList.remove("hidden");
    }
  });
  } catch(e) { console.error(e); }
})();

})();
